import { Skeleton } from '@redriverpress/system'

const placeholders = [...new Array(8)].map((_, index) => ({ key: index }))

export default function UpNextSkeleton() {
  return placeholders.map(ph => (
    <Skeleton
      key={ph.key}
      height='70px'
      width='100%'
      mb={3}
      borderRadius='small'
    />
  ))
}
